module.exports = __webpack_public_path__ + "img/ban_12.168faf21.png";